import { keys, StorageUtils } from "@/features/shared/storage/storage.utils";
import i18next from "@/i18n";
import { Button } from "@EspaceParkQC/sdk-react";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LanguageToggle(): React.ReactElement {
  const { i18n } = useTranslation();

  const toggleLanguage = (): void => {
    const currentLanguage = i18n.language;
    const newLanguage = currentLanguage === "en" ? "fr" : "en";
    void i18next.changeLanguage(newLanguage);
    StorageUtils.setItem(keys.LANGUAGE, newLanguage);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className="px-2"
      onClick={toggleLanguage}
      title={`Switch language. Current: ${i18n.language.toUpperCase()}`}
      aria-label={`Switch language. Current: ${i18n.language.toUpperCase()}`}
    >
      <Languages className="size-2" />
      {i18n.language.toUpperCase()}
    </Button>
  );
}
